module.exports = __webpack_public_path__ + "img/none-bg.d486d292.png";